import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import useStyles from './DetailsCardUseStyles';

const AircraftDetails = props => {
  const { data, subtitles } = props;

  const classes = useStyles();

  return (
    <>
      <Grid item xs={6} className={`${classes.DetailsCard}__value-wrapper`}>
        <span className={`${classes.DetailsCard}__span-title`}>
          {subtitles.originCountry_}
        </span>
        <br />
        <span className={`${classes.DetailsCard}__span-value`}>
          {data.origin_country}
        </span>
      </Grid>
      <Grid item xs={6} className={`${classes.DetailsCard}__value-wrapper`}>
        <span className={`${classes.DetailsCard}__span-title`}>
          {subtitles.icao_}
        </span>
        <br />
        <span className={`${classes.DetailsCard}__span-value`}>
          {data.icao}
        </span>
      </Grid>

      <Grid item xs={6} className={`${classes.DetailsCard}__value-wrapper`}>
        <span className={`${classes.DetailsCard}__span-title`}>
          {subtitles.baroAltitude_}
        </span>
        <br />
        <span className={`${classes.DetailsCard}__span-value`}>
          {data.baro_altitude}
        </span>
      </Grid>
      <Grid item xs={6} className={`${classes.DetailsCard}__value-wrapper`}>
        <span className={`${classes.DetailsCard}__span-title`}>
          {subtitles.verticalSpeed_}
        </span>
        <br />
        <span className={`${classes.DetailsCard}__span-value`}>
          {data.vertical_speed}
        </span>
      </Grid>
    </>
  );
};

export default AircraftDetails;

AircraftDetails.propTypes = {
  data: PropTypes.object.isRequired,
  subtitles: PropTypes.object.isRequired,
};
